import { styled } from "@mui/material";

const PageContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  padding: theme.spacing(2, 3),
  overflowY: "auto",
}));

export default PageContent;
